import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "../../src/assets/css/commoncontrol.css";


export function SaveConfirmModel(props: any) {

    return (

        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header className='modelheader bg-primary header_closebtn'>
                <Modal.Title id="contained-modal-title-vcenter" className='header_text mx-auto h5'>
                    {props?.modletitle ? props.modletitle : "Confirmation"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='modalbody'>
                <p className='text-center fw-bold my-1'>
                    {props?.message ? props.message : "There are unsaved data, do want to save first ?"}
                </p>
            </Modal.Body>
            <Modal.Footer className='modalfooter'>
                <div className='mx-auto'>
                    <Button variant="primary" className='mx-2 px-3' onClick={props.yesconfirm}>
                        Yes
                    </Button>
                    <Button variant="primary" className='mx-2 px-3' onClick={props.noconfirm}>
                        No
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>


    );
}
